import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import logoSmallSvg from '../images/logos/pcc-icon.svg';
import { FaFacebookF } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaLinkedinIn } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa';
import {
    footerWrapper,
    footerRow,
    column,
    columnDesc,
    columnHeading,
    footerLink,
    logoDescWrapper,
    footerLogo,
    rowSocial,
    socialIconWrapper,
    socialIcon,
    bgFacebook,
    bgTwitter,
    bgLinkedin,
    rowLegal,
    rowCopyright,
} from './footer.module.scss';

const Footer = ({ pathname = `` }) => {
    const curYear = new Date().getFullYear();
    const version = useStaticQuery(VERSION_QUERY);

    if (pathname === '/') console.log(version);

    return (
        <footer className={`${footerWrapper} section`}>
            <div className="section-inner">
                <div className={`${footerRow}`}>
                    <div className={`${column} ${columnDesc}`}>
                        <h2 className={`${columnHeading}`}>PaycheckCity</h2>
                        <Link
                            to="/private-label-calculators"
                            className={`${footerLink} btn-text-gray`}>
                            Private label calculators
                        </Link>
                        <Link to="/about-symmetry" className={`${footerLink} btn-text-gray`}>
                            Products by Symmetry
                        </Link>
                        <Link to="/our-story" className={`${footerLink} btn-text-gray`}>
                            Our story
                        </Link>
                        <div className={`${logoDescWrapper}`}>
                            <Link to="/" className={`${footerLogo}`}>
                                <span className="sr-only">PaycheckCity</span>
                                <img
                                    src={logoSmallSvg}
                                    alt={
                                        'PaycheckCity offers free paycheck calculators, tax information, and payroll information.'
                                    }
                                    title={
                                        'Your destination for paycheck calculators, tax research, and running payroll'
                                    }
                                />
                            </Link>
                            <p>
                                PaycheckCity delivers accurate paycheck calculations to tens of
                                millions of individuals, small businesses, and payroll professionals
                                every year since 1999.{' '}
                                <Link to="/our-story" className="btn-text underline">
                                    Read our story.
                                </Link>
                            </p>
                        </div>
                    </div>
                    <div className={`${column}`}>
                        <h2 className={`${columnHeading}`}>Paycheck Calculators</h2>
                        <Link to="/calculator/salary" className={`${footerLink} btn-text-gray`}>
                            Salary calculator
                        </Link>
                        <Link to="/calculator/hourly" className={`${footerLink} btn-text-gray`}>
                            Hourly calculator
                        </Link>
                        <Link to="/calculator/flatbonus" className={`${footerLink} btn-text-gray`}>
                            Bonus calculator
                        </Link>
                        <Link to="/calculator/w4" className={`${footerLink} btn-text-gray`}>
                            Form W-4 wizard
                        </Link>
                        <Link to="/calculator" className={`${footerLink} btn-text-gray`}>
                            More paycheck calculators&hellip;
                        </Link>
                        <Link
                            to="/"
                            className={`${footerLink} btn-text-gray underline-partial icon-animate-bounce`}>
                            <span className="underline-target">Try payroll for free</span>
                            <i className="align-icon text-primary">
                                <FaArrowRight />
                            </i>
                        </Link>
                    </div>
                    <div className={`${column}`}>
                        <h2 className={`${columnHeading}`}>Free Resources and Guides</h2>
                        <Link
                            to="/payroll-resources#payroll-contents"
                            className={`${footerLink} btn-text-gray`}>
                            Payroll tax rates
                        </Link>
                        <Link
                            to="/payroll-resources#withholding-forms"
                            className={`${footerLink} btn-text-gray`}>
                            Withholding forms
                        </Link>
                        <Link
                            to="/small-business-guide/starting-your-business"
                            className={`${footerLink} btn-text-gray underline-partial`}>
                            <span className="underline-target">Starting your business guide</span>
                        </Link>
                        <Link
                            to="/small-business-guide/hiring"
                            className={`${footerLink} btn-text-gray underline-partial`}>
                            <span className="underline-target">Hiring guide</span>
                            &nbsp;<span className="badge">new!</span>
                        </Link>
                        <Link to="/insights" className={`${footerLink} btn-text-gray`}>
                            Payroll insights
                        </Link>
                        <Link
                            to="/states"
                            className={`${footerLink} btn-text-gray underline-partial`}>
                            <span className="underline-target">State by State Payroll & Tax Calculators</span>
                            &nbsp;
                            {/* <span className="badge">new!</span> */}
                        </Link>
                    </div>
                </div>
                <ul className={`${rowSocial}`}>
                    <li>
                        <a
                            href="https://www.facebook.com/PaycheckCity"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${socialIconWrapper}`}>
                            <div className="sr-only">Facebook</div>
                            <div className={`${socialIcon} ${bgFacebook}`}>
                                <FaFacebookF />
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.linkedin.com/company/paycheckcity-payroll"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${socialIconWrapper}`}>
                            <div className="sr-only">LinkedIn</div>
                            <div className={`${socialIcon} ${bgLinkedin}`}>
                                <FaLinkedinIn />
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://twitter.com/PaycheckCity"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${socialIconWrapper}`}>
                            <div className="sr-only">X</div>
                            <div className={`${socialIcon} ${bgTwitter}`}>
                                <FaXTwitter />
                            </div>
                        </a>
                    </li>
                </ul>
                <div className={`${rowLegal}`}>
                    <Link to="/legal/privacy" className={`btn-text-gray`}>
                        Privacy
                    </Link>
                    <span className="text-divider" />
                    <Link to="/legal/terms" className={`btn-text-gray`}>
                        Terms
                    </Link>
                </div>
                <div className={`${rowCopyright}`}>
                    Copyright &copy; 1999-{curYear} Symmetry Software LLC. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

const VERSION_QUERY = graphql`
    {
        versionInfo: pccVersionInfo {
            release
        }
    }
`;

export default Footer;
